<div class="bought-tickets-container" mat-dialog-content>
  <div class="dialog-header">
    @if (showBack) {
      <div class="mobile-back" (click)="goBack()">
        <i class="far fa-chevron-left icon-regular"></i>
      </div>
    }
    <div class="dialog-title-custom">
      @if (selectedTicket) {
        {{ event?.name }} | Ticket {{ selectedTicket.ticketNumber }}
      } @else if (order) {
        {{ event?.name }} |
        {{ order.getOrderDisplayName() | translate }}
      } @else if (orders && orders.length > 0) {
        {{ "APP.TICKETS_DASHBOARD.YOUR_ORDERS" | translate }}
      }
    </div>
    <div class="close-button-custom">
      <i class="far fa-times icon-regular" (click)="close()"></i>
    </div>
  </div>
  @if (order && !this.selectedTicket) {
    <app-ticket-order-card
      [event]="event"
      [order]="order"
      [headerView]="true"
      [loggedUser]="loggedUser"
      (onRequestRefund)="close($event)"
      (onChangeSlotSuccess)="onChangeSlotSuccess($event)"
      class="order-header"
    />
  }
  <div class="dialog-body" [class.bg-secondary]="!selectedTicket && order">
    <div>
      @if (selectedTicket) {
        <app-ticket-order-ticket
          [orderTicket]="selectedTicket"
          [order]="order"
          [event]="event"
          [loggedUser]="loggedUser"
          (close)="close($event)"
        />
      } @else if (order) {
        @if (hasRefund()) {
          <div class="refund-wrapper">
            <div class="refund-info">
              <div class="refund-title">
                <i class="fa-regular" [ngClass]="getRefundProgressIcon()"></i>
                {{ getRefundProgress() }}
              </div>
              <div class="refund-description">
                {{ getRefundProgressDesc() }}
              </div>
            </div>
            @if (order.refund!.isSucceeded()) {
              <button
                class="btn btn-primary"
                (click)="downloadRefundInvoice(order)"
              >
                {{
                  "APP.TICKETS_SETTINGS.ORDERS.DOWNLOAD_REFUND_RECEIPT"
                    | translate
                }}
              </button>
            } @else if (order.refund!.isPending()) {
              <button
                class="btn btn-primary-outline"
                (click)="cancelRefund(order)"
              >
                {{ "APP.REQUEST_REFUND.CANCEL_REFUND_REQUEST" | translate }}
              </button>
            }
          </div>
          <div class="divider"></div>
        }
        <div
          class="order-ticket-categories-cont"
          [class.disabled]="hasRefund()"
        >
          @if (categorizedOrderTickets) {
            @if (categorizedOrderTickets.myTickets.length) {
              <div class="ticket-category-header">
                {{ "APP.TICKETS_DASHBOARD.YOUR_TICKET" | translate }}
              </div>
              <div class="order-tickets-cont">
                @for (
                  orderTicket of categorizedOrderTickets.myTickets;
                  track orderTicket.uuid
                ) {
                  <app-ticket-order-ticket-item
                    [orderTicket]="orderTicket"
                    [ticketIndex]="$index"
                    (selectTicket)="selectTicket($event)"
                    (forwardTicket)="forwardTicket($event)"
                  />
                }
              </div>
            }
            @if (categorizedOrderTickets.unassignedTickets.length) {
              <div class="ticket-category-header">
                {{ "APP.TICKETS_DASHBOARD.UNASSIGNED_TICKETS" | translate }}
              </div>
              <div class="order-tickets-cont">
                @for (
                  orderTicket of categorizedOrderTickets.unassignedTickets;
                  track orderTicket.uuid
                ) {
                  <app-ticket-order-ticket-item
                    [orderTicket]="orderTicket"
                    [ticketIndex]="$index"
                    (selectTicket)="selectTicket($event)"
                    (forwardTicket)="forwardTicket($event)"
                  />
                }
              </div>
            }
            @if (categorizedOrderTickets.assignedTickets.length) {
              <div class="ticket-category-header">
                {{ "APP.TICKETS_DASHBOARD.ASSIGNED_TICKETS" | translate }}
              </div>
              <div class="order-tickets-cont">
                @for (
                  orderTicket of categorizedOrderTickets.assignedTickets;
                  track orderTicket.uuid
                ) {
                  <app-ticket-order-ticket-item
                    [orderTicket]="orderTicket"
                    [ticketIndex]="$index"
                    (selectTicket)="selectTicket($event)"
                    (forwardTicket)="forwardTicket($event)"
                  />
                }
              </div>
            }
            @if (categorizedOrderTickets.notClaimedTickets.length) {
              <div class="ticket-category-header">
                {{ "APP.TICKETS_DASHBOARD.NOT_CLAIMED_TICKETS" | translate }}
              </div>
              <div class="order-tickets-cont">
                @for (
                  orderTicket of categorizedOrderTickets.notClaimedTickets;
                  track orderTicket.uuid
                ) {
                  <app-ticket-order-ticket-item
                    [orderTicket]="orderTicket"
                    [ticketIndex]="$index"
                    (selectTicket)="selectTicket($event)"
                    (forwardTicket)="forwardTicket($event)"
                  />
                }
              </div>
            }
          }
        </div>
      } @else if (orders && orders.length > 0) {
        <div class="orders-cont">
          @for (month of orderMonths; track month) {
            <div class="month-orders-cont">
              <div class="month-display">{{ month }}</div>
              <div class="month-orders">
                @for (order of groupedOrders[month]; track order.uuid) {
                  <app-ticket-order-card
                    [event]="event"
                    [order]="order"
                    [loggedUser]="loggedUser"
                    (selectOrder)="selectOrder($event)"
                    (onRequestRefund)="close($event)"
                    (onChangeSlotSuccess)="onChangeSlotSuccess($event)"
                  />
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
